// import { useOktaAuth } from './service';
import {
  Box,
  Button,
  Toolbar,
  Typography,
} from '@mui/material';

import './index.scss';
import agriPixLogo from '../../assets/icons/agripixlogo.svg';
import { GLOBAL_CONSTANTS } from '../../utils/appConstant';

import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { useAuthHelper } from './authHelper';
import {
  CUSTOM_EVENTS,
  appLogEvent,
} from '../../utils/analytics';

export const OktaSignIn: React.FC = () => {
  // const { login } = useOktaAuth();
  const { instance } = useMsal();

  const callLogin = () => {
    // login();
    appLogEvent(CUSTOM_EVENTS.SSO_SIGN_IN);
    instance.loginRedirect(loginRequest).catch((e) => {
      console.log(e);
    });
  };

  useAuthHelper();

  return (
    <Box className="login-box">
      <Box className="inner-container">
        <Toolbar className="tool-bar">
          <Typography className="welcome-text">
            {GLOBAL_CONSTANTS.WELCOME_MESSAGE}
          </Typography>
          <Box>
            <img
              src={agriPixLogo}
              alt="Nurture Logo"
              height={'45.25px'}
              width={'159.49px'}></img>
          </Box>
        </Toolbar>

        <Box>
          <Typography className="login-text">
            {GLOBAL_CONSTANTS.LOGIN_MESSAGE}
          </Typography>
        </Box>
        <Button
          className="login"
          variant="contained"
          onClick={callLogin}
          fullWidth>
          {GLOBAL_CONSTANTS.LOGIN_BUTTON}
        </Button>
      </Box>
    </Box>
  );
};
